import {Component, computed, input} from '@angular/core';
import {TABLE_ICONS_MAP, TableActionEnum, TableIconEnum} from '@shared/components/table';
import {NbIconModule} from '@nebular/theme';

@Component({
  selector: 'mkad-table-button',
  standalone: true,
  imports: [NbIconModule],
  template: `
    <button class="table__btn"
            [disabled]="disabled()"
            [class]="buttonClass()">
      <nb-icon
        [class]="'text-sm tn_grid_center icon ' + type()"
        [pack]="iconsMap[actionIcon].pack ?? ''"
        [icon]="iconsMap[actionIcon].icon ?? ''"/>
    </button>
  `,
})
export class TableButtonComponent {
  type = input.required<TableActionEnum>();
  //@Input({required: true}) type: TableActionEnum = TableActionEnum.add;
  disabled = input<boolean>(false);
  //@Input({required: false}) disabled = false
  protected readonly iconsMap = TABLE_ICONS_MAP;
  private readonly iconsActionMap: Record<TableActionEnum, TableIconEnum> = {
    [TableActionEnum.update]: TableIconEnum.pen,
    [TableActionEnum.delete]: TableIconEnum.trash,
    [TableActionEnum.customBasic]: TableIconEnum.pen,
    [TableActionEnum.customGroups]: TableIconEnum.groups,
    [TableActionEnum.customParams]: TableIconEnum.params,
    [TableActionEnum.customPorts]: TableIconEnum.ports,
    [TableActionEnum.limits]: TableIconEnum.swap,
    [TableActionEnum.swap]: TableIconEnum.swap,
    [TableActionEnum.row]: TableIconEnum.circleClose,
    [TableActionEnum.userAdd]: TableIconEnum.userAdmin,
    [TableActionEnum.add]: TableIconEnum.add,
  };
  private readonly buttonClassMap: Record<TableActionEnum, string> = {
    [TableActionEnum.update]: 'update',
    [TableActionEnum.delete]: 'delete',
    [TableActionEnum.customBasic]: 'custom-basic',
    [TableActionEnum.customGroups]: 'custom-groups',
    [TableActionEnum.customParams]: 'custom-params',
    [TableActionEnum.customPorts]: 'custom-ports',
    [TableActionEnum.limits]: 'custom-swap',
    [TableActionEnum.swap]: 'custom-swap',
    [TableActionEnum.row]: 'custom-swap',
    [TableActionEnum.userAdd]: 'custom-admin',
    [TableActionEnum.add]: 'create',
  };

  readonly buttonClass = computed(() => {
    const buttonClassValue = [];
    if (!this.disabled()) {
      buttonClassValue.push('cursor-pointer');
    }
    buttonClassValue.push(this.buttonClassMap[this.type()])
    return buttonClassValue.join(' ');
  })

  /**
   * @description
   * Method that returns icons by action.
   */
  get actionIcon(): TableIconEnum {
    return this.iconsActionMap[this.type()];
  }

}
